import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";

class VoucherForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-6">
                        <TextInput
                            name="barcode"
                            value={this.props.values.barcode}
                            label="Vonalkód"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("barcode")}
                            disabled={true}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(VoucherForm);
